<template>
  <div class="detail_information">
    <Flow v-bind:step="3"/>
    <Loading v-show="loading" />
    <Shipping @deliveryData="getDeliveryData" @deliveryAddressData="getDeliveryAddressData" />

    <div v-show="checkSelectRepeatOrder" class="products_wrap bg_white mt12 pt16 pb16">
      <!-- <div class="products_wrap bg_white mt12 pt16 pb16"> -->
      <h2 class="content_title">お支払い方法</h2>

      <div class="payment_wrap mt24 c5a" v-show="this.getPaymentMethodList.paymentMethodList.length != 0">
        <div v-for="(value, n) in getPaymentMethodList.paymentMethodList" class="payment_item bdb pl16 pr20 pb10" v-bind:class="{ 'pt19' : n != 0 }" :key="n">
          <div :class="{ disable: (value.paymentMethodId == 2 && checkNselection()) || hasGoodDealItems }">
            <input :id="'payment'+ value.paymentMethodId" class="payment_radio" type="radio" name="payment" :checked="value.paymentMethodId == detailData.paymentData.paymentMethodId" :disabled="hasGoodDealItems">
            <label :for="'payment'+ value.paymentMethodId" class="payment_contents rb" v-on:click="!hasGoodDealItems ? selectPayment(value.paymentMethodId) : null">{{ value.paymentMethodName }}</label>
          </div>

          <div v-if="detailData.paymentData.paymentMethodId == 4" class="credit_label right_arrow" v-bind:class="{'select': value.paymentMethodId == 4}">
            <!-- <span v-if="detailData.selectCreditData.cardNo" class="credit_number rr" v-on:click="selectCredit()">{{ detailData.selectCreditData.cardNo }}</span> -->
            <span v-if="detailData.selectCreditData.cardNo" class="credit_number rr" v-on:click="!hasGoodDealItems ? selectCredit() : null">
              <span v-if="!subscriptionViewSameWithBc001" class="">
                {{ detailData.selectCreditData.cardNo }}
                <CreditcardExpired :expired="detailData.selectCreditData.expired" :expireYearMonth="detailData.selectCreditData.expireYearMonth" />
              </span>
            </span>
            <span v-else class="credit_number rr" v-on:click="!hasGoodDealItems ? selectCredit() : null">クレジットカードが登録されていません</span>
            <!-- store使う用  <span v-if="detailData.selectCreditData.cardNo" class="credit_number rr" v-on:click="selectCredit()">{{ detailData.selectCreditData.cardNo }}</span>
            <span v-else class="credit_number rr" v-on:click="selectCredit()">クレジットカードが登録されていません</span> -->
            <p class="sameWithCredit sameWithBc rr c5a" v-on:click="!hasGoodDealItems ? selectCredit() : null" v-if="subscriptionViewSameWithBc001">※BC001のクレジットカード情報を使用します。</p>
          </div>

        </div>
      </div>
      <p class="pl16 pr16 mt16 nselection_text ab">定期購入へ設定した製品の全てのお支払い方法が変わります。</p>
    </div>

    <div v-show="detailData.paymentData.paymentMethodId == 4" class="products_wrap bg_white mt12 pt16 pb16">
      <h2 class="content_title rb delyvery_flag">クレジットカード決済不可時は、<br>製品を「代金引換便」でお届けする</h2>
      <div class="payment_wrap mt24 c5a">
        <div class="payment_item bdb pl16 pr20 pb10">
          <div>
            <input @change="ChangedenyCreditDeliveryFlag" id="denyCreditDeliveryFlag" class="payment_radio" type="checkbox" name="denyCreditDeliveryFlag" :checked="subscriptionDenyCreditDeliveryFlag">
            <label for="denyCreditDeliveryFlag" class="payment_contents rb" v-on:click="">設定する</label>
          </div>
        </div>
      </div>
      <p class="pl16 pr16 mt16 nselection_text ab">何らかの理由によりクレジットカード決済ができなかった場合は、「代金引換便」で製品をお届けします。</p>

    </div>
    <!-- クレジット情報変更画面 -->
    <SelectCredit ref="openCreditSelect" v-bind:pageName="this.subscription" @close="closeCredit" @selectData="sendCredit" />
    <div class="products_wrap bg_white mt12 pt32 pb48">
      <a href="#" class="btn_blue" @click.stop.prevent="nextBtn()">次へ</a>
      <router-link class="btn_delete back_btn" :to="{ name: 'subSelectProductsList' }">戻る</router-link>
    </div>
    <ErrorModal v-show="isModalOpen" :errorMessage="errorMessage" @modalClose="modalClose" />
  </div>
</template>

<script>
import Loading from '@/components/common/Loading'
import Flow from '@/components/subscription/Flow'
import SelectCredit from '@/components/common/SelectCredit'
import Shipping from '@/components/subscription/Shipping'

import Bank from '@/components/api/bank'
import RepeatOrder from '@/components/api/repeatOrder'
import scrollPosition from '@/model/scrollPosition';
import CheckOrder from '@/model/checkSelectRepeatOrder';
import { mapGetters } from 'vuex';
import ErrorModal from '@/components/common/ErrorModal';
import CreditcardExpired from '@/components/common/CreditcardExpired.vue';

export default {
  components: {
    Flow,
    SelectCredit,
    Shipping,
    Loading,
    ErrorModal,
    CreditcardExpired
  },
  data() {
    return {
      isModalOpen: false,
      errorMessage: 'お支払い方法が選択されていません',
      sameWithCredit: '',
      loading: false,
      simulate: [],
      selectCreditOpen: false,
      subscription: 'subscription',
      getPaymentMethodList: {
        selectedPaymentMethodId: null,
        paymentMethodList: []
      },
      detailData: {
        deliveryTimeData: {
          deliveryTimeId: null,
          deliveryTimeName: '',
        },
        deliveryAddressData: {
          recipientName: '',
          deliveryAddressId: null,
          zipCode: '',
          prefectureName: '',
          address: '',
          sameWithBc001: false,
        },
        paymentData: {
          paymentMethodId: null,
          paymentMethodName: ''
        },
        selectCreditData: {
          cardBrand: '',
          cardNo: '',
          creditCardId: '',
          expireYearMonth: null,
          expired: false,
          holderName: '',
          selected: false,
          sameWithBc001: false,
        },
        selectCoupon: {
          name: '',
          use: 0
        },
      },
      denyCreditDeliveryFlag: false,
    }
  },
  methods: {
    getDeliveryData(data) {
      // Shippingコンポーネントからデータの受け取り
      // this.detailData.shippingTimeSelected = data;
      this.detailData.deliveryTimeData.deliveryTimeId = data.deliveryTimeId;
      this.detailData.deliveryTimeData.deliveryTimeName = data.deliveryTimeName;
    },
    getDeliveryAddressData(data) {
      this.detailData.deliveryAddressData.recipientName = data.recipientName;
      this.detailData.deliveryAddressData.deliveryAddressId = data.deliveryAddressId;
      this.detailData.deliveryAddressData.zipCode = data.zipCode;
      this.detailData.deliveryAddressData.prefectureName = data.prefectureName;
      this.detailData.deliveryAddressData.address = data.address;
      this.detailData.deliveryAddressData.sameWithBc001 = data.sameWithBc001;
    },
    selectPayment(number) {
      // goodDealが含まれている場合は支払い方法の変更をブロック
      if (this.hasGoodDealItems) {
        return;
      }

      this.detailData.paymentData.paymentMethodId = number;
      let index = this.getPaymentMethodList.paymentMethodList.findIndex((value) => value.paymentMethodId == number);
      this.detailData.paymentData.paymentMethodName = this.getPaymentMethodList.paymentMethodList[index].paymentMethodName;

      this.storeActionsPaymentData();
    },
    selectCredit() {
      // goodDealが含まれている場合はクレジットカード選択をブロック
      if (this.hasGoodDealItems) {
        return;
      }

      scrollPosition.open();
      // SelectCreditコンポーネントの関数実行
      this.$refs.openCreditSelect.refsOpen();
    },
    closeCredit() {
      this.selectCreditOpen.open = false;
    },
    sendCredit(data) {
      if(data.creditCardId != 0) {
        this.detailData.selectCreditData.creditCardId = data.creditCardId;
      }
      this.detailData.selectCreditData.cardBrand = data.cardBrand;
      this.detailData.selectCreditData.cardNo = data.cardNo;

      this.detailData.selectCreditData.expireYearMonth = data.expireYearMonth;
      this.detailData.selectCreditData.expired = data.expired;
      this.detailData.selectCreditData.holderName = data.holderName;
      this.detailData.selectCreditData.selected = data.selected;
      this.detailData.selectCreditData.sameWithBc001 = data.sameWithBc001;
    },
    modalOpen() {
      scrollPosition.open();
      this.isModalOpen = true;
    },
    modalClose() {
      scrollPosition.close();
      this.isModalOpen = false;
    },
    nextBtn () {
      if(this.checkSelectRepeatOrder) {
        if(this.detailData.paymentData.paymentMethodId && this.detailData.deliveryTimeData.deliveryTimeId && this.detailData.deliveryAddressData.deliveryAddressId) {
          this.apiSimulate();
        }else {
          this.modalOpen();
          return false;
        }
      } else {
        this.$router.push({ name: 'subConfirm' });
      }

      localStorage.setItem('userDetail', JSON.stringify(this.userDetail));

      // localStorage.setItem('userDetail', JSON.stringify(this.detailData)); // JSONに変換

    },
    storageData() {
      let userDetail = JSON.parse(localStorage.getItem('userDetail'));
      if(userDetail) {
        this.detailData.paymentData.paymentMethodId = userDetail.paymentData.paymentMethodId;
        this.detailData.paymentData.paymentMethodName = userDetail.paymentData.paymentMethodName;
      }
      this.storeActionsPaymentData();
    },
    storeActionsPaymentData() {
      this.$store.dispatch('commitUserDetailPaymentData', { paymentMethodId: this.detailData.paymentData.paymentMethodId, paymentMethodName: this.detailData.paymentData.paymentMethodName, paymentMethod: '' });
    },
    async apiGetPaymentMethodList() {
      await RepeatOrder.repeatGetPayment().then((val) => {
        // 表示用
        this.getPaymentMethodList.paymentMethodList.push(...val.paymentMethodList);
        // 初期paymentName
        let index = this.getPaymentMethodList.paymentMethodList.findIndex((value) => value.paymentMethodId == val.selectedPaymentMethodId);
        (index != -1) ? this.detailData.paymentData.paymentMethodName = this.getPaymentMethodList.paymentMethodList[index].paymentMethodName : this.detailData.paymentData.paymentMethodName = this.getPaymentMethodList.paymentMethodList[0].paymentMethodName;
        // id
        this.getPaymentMethodList.selectedPaymentMethodId = val.selectedPaymentMethodId;
        this.detailData.paymentData.paymentMethodId = val.selectedPaymentMethodId;

        this.storeActionsPaymentData();
      });
    },
    async apiSimulate() {
      this.loading = true;
      const deliveryTimeId = this.detailData.deliveryTimeData.deliveryTimeId;
      const paymentMethodId = this.detailData.paymentData.paymentMethodId;
      const denyCreditDeliveryFlag = this.subscriptionDenyCreditDeliveryFlag;
      let repeatItems = JSON.parse(localStorage.getItem('repeatItemList'));
      let repeatOrderList = [];
      if(repeatItems) {
        for (var i = 0; i < repeatItems.length; i++) {
          repeatOrderList.push(...repeatItems[i].itemList);
        }
      }
      await RepeatOrder.simulate(deliveryTimeId, paymentMethodId, repeatOrderList, denyCreditDeliveryFlag).then((val) => {
        this.loading = false;
        localStorage.setItem('simulateResponse', JSON.stringify(val));
        this.$router.push({ path: 'shippingPlan' });
      });
    },
    checkNselection() {
      let result = false;
      let items = JSON.parse(localStorage.getItem('repeatItemList'));

      if(items) {
        let nselectionIndex = items.findIndex(({genreId}) => genreId == 3);
        // nselectionIndexが-1の場合はnselection商品がない
        if(nselectionIndex == -1) {
          return false;
        }
        result = items[nselectionIndex].itemList.some(({repeatOrder}) => repeatOrder == true);
      }

      return result;
    },
    ablePaymentMethodIdList() {
      /*
      定期一覧にNselection商品があり定期購入している場合: 特定の支払い方法のみ使用できる
      定期一覧にNselection商品があり定期購入していない場合: 全ての支払い方法が選択できる
      定期一覧にNselection商品がない場合: 全ての支払い方法が選択できる
      */
      const nselectionGenreId = 3;
      console.log("ablePaymentMethodIdList");
      let itemList = JSON.parse(localStorage.getItem('repeatItemList'));
      const existRepeatItem = JSON.parse(localStorage.getItem('existRepeatItem'));
      // this.getPaymentMethodList.paymentMethodList
      const isNselectionAvailableItemList = itemList.some(({genreId}) => genreId == nselectionGenreId); // 商品一覧にNselection商品があればTrue
      console.log("isNselectionAvailableItemList", isNselectionAvailableItemList);
      if (existRepeatItem && existRepeatItem.length > 0) {
        const hasNselectionGenre = existRepeatItem.some(item =>
          item.product.genre.genreId === nselectionGenreId
        );

        if (hasNselectionGenre) {
          console.log("Nselection商品が定期購入リストに存在します。");
        } else {
          console.log("Nselection商品が定期購入リストに存在しません。");
        }
      }
    },
    async apiGetDenyCreditDelivery(nowBC) {
      await RepeatOrder.getDenyCreditDelivery(nowBC).then((val) => {
        if(this.subscriptionDenyCreditDeliveryFlag == null) {
          // storeにデータを保存していない場合のみ保存
          // this.denyCreditDeliveryFlag = val.denyCreditDeliveryFlag;
          this.$store.commit('setSubscriptionDenyCreditDeliveryFlag', val.denyCreditDeliveryFlag);
        }
      });
    },
    ChangedenyCreditDeliveryFlag() {
      let changeFlag = null;
      this.subscriptionDenyCreditDeliveryFlag ? changeFlag = false : changeFlag = true;
      // this.denyCreditDeliveryFlag = changeFlag;
      this.$store.commit('setSubscriptionDenyCreditDeliveryFlag', changeFlag);
    },
    // goodDealが含まれている商品があるかチェックする関数
    checkGoodDealItems() {
      let items = JSON.parse(localStorage.getItem('repeatItemList'));
      if (!items) return false;

      // 全ての商品リストをチェック
      for (let i = 0; i < items.length; i++) {
        const itemList = items[i].itemList;
        for (let j = 0; j < itemList.length; j++) {
          // repeatOrderがtrueかつgoodDealがtrueの商品があるかチェック
          if (itemList[j].repeatOrder && itemList[j].goodDeal) {
            return true;
          }
        }
      }
      return false;
    },
  },
  computed: {
    ...mapGetters(['checkSelectRepeatOrder', 'subscriptionViewSameWithBc001', 'userDetail', 'subscriptionNowBC', 'subscriptionDenyCreditDeliveryFlag']),

    // goodDealが含まれているかのcomputed property
    hasGoodDealItems() {
      return this.checkGoodDealItems();
    }
  },
  async created () {
    // let result = CheckOrder.checkSelectRepeatOrder();
    // this.checkSelectRepeatOrder ? '' : this.showPayment = false;
    await this.apiGetPaymentMethodList();
    await this.storageData();
    await this.apiGetDenyCreditDelivery(this.subscriptionNowBC);
    this.ablePaymentMethodIdList();
  }
}
</script>

<style lang="css" scoped>
.sameWithBc {
  /* color: red; */
  /* font-size: 13px; */
  font-size: 15px;
}
.content_title {
  width: 123px;
}
.content_title.delyvery_flag {
  width: 260px;
}


.detail_information .address {
  font-size: 14px;
  margin-top: 3px;
}
.address_text {
  margin-left: 8px;
}

.credit_number {
  display: block;
  font-size: 14px;
}

.credit_label {
  display: none;
  margin-top: 15px;
  padding-left: 28px;
}

.credit_label.select {
  display: block;
}

.no_coupon {
  margin-bottom: 24px;
  padding-bottom: 5px;
}

.coupon_title {
  border-left: 4px solid  #4FCCD4;
  font-size: 16px;
  padding-left: 4px;
}

.coupon_item {
  align-items: flex-end;
  display: flex;
  margin-top: 27px;
}
.possession_coupon {
  display: flex;
  width: 68%;
}

.possession_count, .can_count {
  font-size: 12px;
}
.possession_count--number, .can_count--number {
  font-size: 18px;
  margin-left: 9px;
}

.can_count {
  margin-left: 26px;
}

.use_wrap {
  align-items: center;
  display: flex;
  margin-left: 8px;
  width: 30%;
}
.use_text {
  font-size: 12px;
  min-width: 40px;
}


.select_wrap.bottom_arrow::after {
  bottom: 7px;
  right: 22px;
}

.payment_item .right_arrow::after {
  right: 5px;
}

.disable {
  position: relative;
}
.disable::before {
  background-color: #aaa;
  content: '';
  height: 100%;
  left: 0;
  opacity: .5;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 4;
}

.nselection_text {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/subscription/SubDetailInformation.vue